<template>
  <ViewCustomRow @refreshRow="refreshRow" @addNewRow="addNewRow" @hide="onHideDialog" v-model:showRowDialog="showDialog"
    :rowId="rowId" :masterDetail="masterDetail" :dialogOptions="dialogOptions" :permissions="permissions"
    :entityKey="entityKey" entityName="facility" entitySpec="data" ref="FacilityDialog"
    :requiredFields="FACILITY_DIALOG_REQUIRED_FILEDS" :dictionary="FACILITY_DIALOG_DICTIONARY"
    :style="{ width: '90%' }">
    <template #header="{ rowData }">
      {{
        rowId === -1
          ? "Новый объект"
          : rowData.facility_name
            ? `Объект: ${rowData.facility_name}`
            : ""
      }}
    </template>
    <template #body="{ rowData, reference, submitted }">
      <div class="formgrid grid align-items-center vertical-container">
        <div class="col-12">
          <div class="formgrid grid align-items-center vertical-container">
            <div class="col-1">
              <label for="facility_name" class="mb-1">Наименование: </label>
            </div>
            <div class="col-2">
              <InputText id="facility_name" placeholder="Имя объекта" autofocus v-model="rowData.facility_name" :class="{
                'p-invalid': submitted ? (rowData.facility_name || '') == '' : false,
              }">
              </InputText>
            </div>
            <div class="col-1">
              <label for="date_transfer">Тип:</label>
            </div>
            <div class="col-2">
              <Dropdown id="dept_id" v-model="rowData.facility_type_id"
                :options="reference['facilityType'] ? reference['facilityType'] : []" optionLabel="facility_type_name"
                optionValue="facility_type_id" placeholder="Тип объекта" appendTo="body" :disabled="rowId !== -1"
                :class="{
                  'p-invalid': submitted ? (rowData.facility_type_id || '') == '' : false,
                }"></Dropdown>
            </div>
            <div class="col-1">
              <label for="facility_process_rate">Период обраб, сек:</label>
            </div>
            <div class="col-1">
              <InputNumber id="facility_process_rate" v-model="rowData.facility_process_rate" mode="decimal" showButtons
                :min="0" :max="1000" :class="{
                  'p-invalid': submitted
                    ? (rowData.facility_process_rate || '') == ''
                    : false,
                }" />
            </div>
            <div class="col-1">
              <label for="script_id">Lat, lon:</label>
            </div>
            <div class="col-1">
              <InputNumber id="facility_process_rate" v-model="rowData.facility_coord_ltd" mode="decimal" showButtons
                :step="0.000001" :min="-90" :max="90" :minFractionDigits="3" :maxFractionDigits="6" />
            </div>
            <div class="col-1">
              <InputNumber id="facility_process_rate" v-model="rowData.facility_coord_lng" mode="decimal" showButtons
                :step="0.000001" :min="-180" :max="180" :minFractionDigits="3" :maxFractionDigits="6" />
            </div>
          </div>
          <div class="formgrid grid align-items-center vertical-container mt-1">
            <div class="col-1">
              <label for="dept_id" class="mb-1">Компания:</label>
            </div>
            <div class="col-2">
              <Dropdown id="dept_id" v-model="rowData.dept_id" :options="actualDept" optionLabel="dept_name"
                optionValue="dept_id" placeholder="Подразделение" appendTo="body" :class="{
                  'p-invalid': submitted ? (rowData.dept_id || '') == '' : false,
                }"></Dropdown>
            </div>

            <div class="col-1">
              <label for="script_id">Дизайн:</label>
            </div>
            <div class="col-2">
              <Dropdown id="script_id" v-model="rowData.script_id"
                :options="reference['script'] ? reference['script'] : []" optionLabel="script_name"
                optionValue="script_id" placeholder="Дизайн" appendTo="body" filter></Dropdown>
            </div>
            <div class="col-1">
              <label for="facility_position">Позиция:</label>
            </div>
            <div class="col-1">
              <InputNumber id="facility_position" v-model="rowData.facility_position" mode="decimal" showButtons
                :min="0" :max="1000" />
            </div>
            <div class="col-1">
              <label for="facility_mode_id">Сост. объекта:</label>
            </div>
            <div class="col-1">
              <Dropdown id="facility_mode_id" v-model="rowData.facility_mode_id"
                :options="reference['facilityMode'] ? reference['facilityMode'] : []" optionLabel="facility_mode_name"
                optionValue="facility_mode_id" placeholder="Состояние" appendTo="body"></Dropdown>
            </div>
          </div>
          <div class="formgrid grid align-items-center vertical-container mt-1">
            <div class="col-1">
              <label v-if="tabIndex === 2 || tabIndex === 1 || tabIndex === 0" for="script_id">Объект синх.:</label>
            </div>
            <div class="col-2">
              <Dropdown v-if="tabIndex === 2 || tabIndex === 1 || tabIndex === 0" v-model="synchFacilityId" showClear
                :options="$store.getters.facility" optionLabel="facility_name" optionValue="facility_id"
                placeholder="Объект" appendTo="body" filter></Dropdown>
            </div>
            <div class="col-1-5">
              <Button v-if="tabIndex === 2 || tabIndex === 1 || tabIndex === 0"
                :label="modeSynch === 'clone' ? 'Клонирование' : 'Синхронизация'" severity="success" :icon="modeSynch === 'synchronize'
                  ? 'pi pi-spin pi-spinner'
                  : modeSynch === 'clone'
                    ? 'pi pi-spin pi-cog'
                    : 'pi pi-spinner'
                  " :disabled="!synchFacilityId || rowId < 0 || modeSynch" @click="synchronization()" />
            </div>
            <div class="col-0-5"></div>
            <div class="col-1 col-offset-5">
              <Button v-if="tabIndex === 2 || tabIndex === 1 || tabIndex === 0" label="Экспорт" icon="pi pi-file-export"
                :disabled="rowId < 0 || !$store.getters.info.isAdmin" @click="onClickExport(rowData)" />
            </div>
            <div class="col-1">
              <FileUpload v-if="tabIndex === 2 || tabIndex === 1 || tabIndex === 0" mode="basic" name="demo[]"
                url="/api/upload" accept=".xml" customUpload chooseLabel="Импорт" @uploader="onUploadImportFile"
                style="width: 100%" :disabled="checkDisabledImport()">
              </FileUpload>
            </div>
          </div>
        </div>
      </div>
      <TabView @tab-change="onTabChange($event.index)" class="mt-1" style="min-height: 600px">
        <TabPanel header="Свойства (диалог)">
          <FacilityPropertyWithDlg v-if="rowId > 0 && tabIndex === 0" :facilityId="rowId"
            @changeDevice="onClickChangeDevice" @changePath="onClickChangePath" @selected="changePropertyFacility"
            @loadData="loadData" @dictIsReady="dictIsReady" />
          <Panel header="Параметры свойств" toggleable style="min-height: 200px">
            <TabView>
              <TabPanel header="Атрибуты">
                <div class="formgrid grid align-items-center vertical-container mt-1">
                  <div class="col-9">
                    <PropertyData v-if="rowId > 0 && tabIndex === 0 && propertyId > 0" :propertyId="propertyId"
                      @loadData="loadData" @selected="changeAttribute" />
                  </div>
                  <div class="col-3">
                    <div class="formgrid grid align-items-center vertical-container mt-1">
                      <div class="col-1">
                        <Divider layout="vertical"> </Divider>
                      </div>
                      <div class="col-11">
                        <label for="">{{ attributeText }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="События">
                <PropertyEvent
                  v-if="rowId > 0 && (tabIndex === 0 || tabIndex === 1 || tabIndex === 2) && propertyId > 0"
                  :data="{ property_id: propertyId }" source="property_id" nullable="property_type_id" />
              </TabPanel>
            </TabView>
          </Panel>
        </TabPanel>
        <TabPanel header="Свойства">
          <FacilityProperty v-if="rowId > 0 && tabIndex === 1" :facilityId="rowId" @changeDevice="onClickChangeDevice"
            @changePath="onClickChangePath" @selected="changePropertyFacility" @loadData="loadData"
            @dictIsReady="dictIsReady" />
          <Panel header="Параметры свойств" toggleable style="min-height: 200px">
            <TabView>
              <TabPanel header="Атрибуты">
                <div class="formgrid grid align-items-center vertical-container mt-1">
                  <div class="col-9">
                    <PropertyData v-if="rowId > 0 && tabIndex === 1 && propertyId > 0" :propertyId="propertyId"
                      @loadData="loadData" @selected="changeAttribute" />
                  </div>
                  <div class="col-3">
                    <div class="formgrid grid align-items-center vertical-container mt-1">
                      <div class="col-1">
                        <Divider layout="vertical"> </Divider>
                      </div>
                      <div class="col-11">
                        <label for="">{{ attributeText }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="События">
                <PropertyEvent
                  v-if="rowId > 0 && (tabIndex === 0 || tabIndex === 1 || tabIndex === 2) && propertyId > 0"
                  :data="{ property_id: propertyId }" source="property_id" nullable="property_type_id" />
              </TabPanel>
            </TabView>
          </Panel>
        </TabPanel>
        <TabPanel header="Фланцы(усы)">
          <div class="formgrid grid align-items-center vertical-container">
            <div class="col-8">
              <FacilityFlange v-if="rowId > 0 && (tabIndex === 0 || tabIndex === 1 || tabIndex === 2)"
                :facilityId="rowId" @loadData="loadData" />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Подключения фланцев">
          <div class="formgrid grid align-items-center vertical-container">
            <div class="col-8-5">
              <FacilityDiagram v-if="rowId > 0 && tabIndex === 3" :facilityId="rowId" />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Устройства">
          <div class="formgrid grid align-items-center vertical-container">
            <div class="col-9">
              <FacilityDevice v-if="rowId > 0 && tabIndex === 4" :facilityId="rowId" />
            </div>
          </div>
        </TabPanel>
      </TabView>
    </template>
  </ViewCustomRow>
  <Dialog v-model:visible="replace.showMenuPath" :style="{ width: '400px' }" modal>
    <template #header>
      <i class="pi pi-question-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
      <div class="col-10 font-bold text-center" style="font-size: 1.3rem">
        Заменить путь(path)
      </div>
    </template>
    <div v-if="replace.loading" class="text-center">
      <ProgressSpinner />
    </div>
    <div v-else>
      <div class="formgrid grid align-items-center mt-1">
        <div class="col-4">
          <label for="search_path">Найти: </label>
        </div>
        <div class="col-8">
          <InputText id="search_path" placeholder="Найти" autofocus v-model="replace.searchPath" class="w-full">
          </InputText>
        </div>
      </div>
      <div class="formgrid grid align-items-center mt-2">
        <div class="col-4">
          <label for="replace_path">Заменить на: </label>
        </div>
        <div class="col-8">
          <InputText id="replace_path" placeholder="Заменить на" autofocus v-model="replace.replacePath" class="w-full">
          </InputText>
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Отмена" icon="pi pi-times" class="p-button-text" @click="replace.showMenuPath = false" />
      <Button label="Заменить всё" icon="pi pi-check" class="p-button-text" :disabled="!replace.searchPath?.length"
        @click="onClickReplaceAllPath" />
    </template>
  </Dialog>

  <Dialog v-model:visible="replace.showMenuDevice" :style="{ width: '400px' }" modal
    @hide="replace.replaceDeviceId = null">
    <template #header>
      <i class="pi pi-question-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
      <div class="col-10 font-bold text-center" style="font-size: 1.3rem">
        Заменить устройство
      </div>
    </template>
    <div v-if="replace.loading" class="text-center">
      <ProgressSpinner />
    </div>
    <div v-else>
      <div class="formgrid grid align-items-center mt-1">
        <div class="col-3">
          <label for="replace_device">Выберите устройство: </label>
        </div>
        <div class="col-9">
          <Dropdown id="replace_device" v-model="replace.replaceDeviceId" autofocus class="w-full" :options="device"
            optionLabel="device_name" optionValue="device_id" appendTo="body">
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Отмена" icon="pi pi-times" class="p-button-text" @click="replace.showMenuDevice = false" />
      <Button label="Заменить всё" icon="pi pi-check" class="p-button-text" :disabled="!replace.replaceDeviceId"
        @click="onClickReplaceAllDevice" />
    </template>
  </Dialog>
</template>

<script>
import { ref, reactive, computed, onMounted, getCurrentInstance, shallowRef } from 'vue'
import { ViewCustomRow } from 'cdisoft-library';
import FacilityPropertyWithDlg from './FacilityPropertyWithDlg.vue'
import FacilityProperty from './FacilityProperty.vue'
import FacilityFlange from './FacilityFlange.vue'
import FacilityDiagram from './FacilityDiagram.vue'
import FacilityDevice from './FacilityDevice.vue'
import PropertyData from './PropertyData.vue'
import PropertyEvent from '../property/PropertyEvent.vue'
import { rtfToTxt } from '../property/rtf_converter.js'
import { FACILITY_DIALOG_DICTIONARY, FACILITY_DIALOG_REQUIRED_FILEDS } from './facilityConstants'

export default {
  name: 'FacilityDialog',
  components: {
    FacilityFlange,
    FacilityDiagram,
    FacilityDevice,
    PropertyData,
    PropertyEvent,
    FacilityPropertyWithDlg,
    FacilityProperty,
  },
  mixins: [ViewCustomRow],
  setup(props, context) {
    const { proxy } = getCurrentInstance()

    const tabIndex = ref(0);
    const attributeText = ref('');
    const propertyId = ref(null);
    const synchFacilityId = ref(null);
    const isImportLoading = ref(false);
    const modeSynch = ref(null);
    const source = reactive({});
    const device = ref([]);
    const replace = reactive({
      showMenuPath: false,
      showMenuDevice: false,
      replacePath: null,
      searchPath: null,
      replaceDeviceId: null,
      service: null,
      loading: false,
    })
    const dept_id = ref(null);

    const actualDept = computed(() => {
      return proxy.$store.getters.dept.filter(
        (item) => item.dept_actual || item.dept_id === dept_id.value
      );
    })

    const loadData = (data, sourceName) => {
      source[sourceName] = data;
    }

    const dictIsReady = (options, data) => {
      if (options === 'device') device.value = data;
    }

    const onClickReplaceAllPath = () => {
      if (!source['FacilityProperty']?.length) return;
      const promises = [];
      replace.loading = true;
      for (let index = 0; index < source['FacilityProperty'].length; index++) {
        const property = source['FacilityProperty'][index];
        const pathNew = replaceInPath(property.property_path, replace.searchPath, replace.replacePath);
        if (pathNew)
          promises.push(replace.service.putData({ property_id: property.property_id, property_path_new: pathNew }, 'path'));
      }
      Promise.all(promises)
        .catch((er) =>
          proxy.$store.commit('SET_ERROR', {
            er: er.response || er,
            source: ['FacilityDialog', 'onClickReplaceAllPath'],
          })
        )
        .finally(() => {
          onClickUpdateFacilityProperty();
          replace.loading = false;
          replace.showMenuPath = false;
        })
    }

    const replaceInPath = (path, searchText, replaceText) => {
      if (!path) return null;
      if (path.includes(searchText)) {
        return path.replace(new RegExp(searchText, 'g'), replaceText);
      }
      return null;
    }

    const onClickReplaceAllDevice = () => {
      if (!replace.replaceDeviceId) return;
      const promises = [];
      replace.loading = true;
      for (let index = 0; index < source['FacilityProperty'].length; index++) {
        const property = source['FacilityProperty'][index];
        promises.push(replace.service.putData({ property_id: property.property_id, device_id_new: replace.replaceDeviceId }, 'device'));
      }
      Promise.all(promises)
        .catch((er) =>
          proxy.$store.commit('SET_ERROR', {
            er: er.response || er,
            source: ['FacilityDialog', 'onClickReplaceAllDevice'],
          })
        )
        .finally(() => {
          onClickUpdateFacilityProperty();
          replace.loading = false;
          replace.showMenuDevice = false;
        })
    }

    const onClickChangePath = () => {
      replace.showMenuPath = true;
      onClickUpdateFacilityProperty();
    }

    const onClickChangeDevice = () => {
      replace.showMenuDevice = true;
      onClickUpdateFacilityProperty();
    }

    const onClickUpdateFacilityProperty = () => {
      const btn = document.querySelector('[data-testid="update_property_data"]');
      if (btn) btn.click();
    }

    const checkDisabledImport = () => {
      return (
        source['FacilityFlange']?.length > 0 ||
        source['FacilityProperty']?.length > 0 ||
        source['FacilityFlange']?.length > 0 ||
        proxy.rowId < 0 ||
        isImportLoading.value ||
        !proxy.$store.getters.info.isAdmin
      );
    }

    const onUploadImportFile = (event) => {
      const file = event.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const fileContent = e.target.result;
          const domParser = new DOMParser();
          const xmlDOM = domParser.parseFromString(fileContent, 'text/xml');
          const facilityFlnages = xmlDOM.querySelector('facility_flanges');
          const properties = xmlDOM.querySelector('properties');
          const propertyDatas = xmlDOM.querySelector('property_datas');
          isImportLoading.value = true;
          proxy.$refs.FacilityDialog['BaseService']
            .execProc('web4.facility__import', {
              facility_id: proxy.rowId,
              xml_facility_flange: facilityFlnages.outerHTML,
              xml_property: properties.outerHTML,
              xml_property_data: propertyDatas ? propertyDatas.outerHTML : '',
            })
            .then(() =>
              proxy.$toast.add({
                severity: 'success',
                summary: 'Импорт завершён',
                detail: 'Объект успешно импортирован из XML. Обновите страницу для просмотра изменений.',
                life: 5000,
              })
            )
            .catch((er) =>
              proxy.$store.commit('SET_ERROR', {
                er: er.response || er,
                source: ['FacilityDialog', 'Exporting', 'facility__import'],
              })
            )
            .finally(() => (isImportLoading.value = false))
        } catch (error) {
          proxy.$store.commit('SET_ERROR', {
            er: error,
            source: ['FacilityDialog', 'Exporting', 'onload'],
          });
        }
      }
      reader.readAsText(file)
    }

    const onClickExport = (rowData) => {
      proxy.$refs.FacilityDialog['BaseService']
        .execProc('dbo.facility__export', {
          facility_id: proxy.rowId,
        })
        .then((data) => prepareExport(data[0], rowData))
        .catch((er) =>
          proxy.$store.commit('SET_ERROR', {
            er: er.response || er,
            source: ['FacilityDialog', 'Exporting', 'facility__export'],
          })
        )
    }

    const prepareExport = (data, rowData) => {
      const xml = `<facility> ${data.xml_facility_flange || ''}${data.xml_property || ''}${data.xml_property_data || ''} </facility>`;
      const fileName = `${rowData.facility_type_sname}-${rowData.facility_name}.xml`;
      download(fileName, xml);
    }

    const download = (filename, text) => {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }

    const synchronization = () => {
      if (
        source['FacilityFlange']?.length === 0 &&
        source['FacilityProperty']?.length === 0
      ) {
        modeSynch.value = 'clone';
        proxy.$refs.FacilityDialog['BaseService']
          .execProc('web4.facility__clone', {
            facility_id: proxy.rowId,
            facility_clone_id: synchFacilityId.value,
          })
          .then(() =>
            proxy.$toast.add({
              severity: 'success',
              summary: 'Клонирование завершено',
              detail: 'Объект успешно скопирован. Обновите страницу для просмотра.',
              life: 5000,
            })
          )
          .catch((er) =>
            proxy.$store.commit('SET_ERROR', {
              er: er.response || er,
              source: ['FacilityDialog', 'Synchronization', 'facility__clone'],
            })
          )
          .finally(() => (modeSynch.value = null))
      } else {
        modeSynch.value = 'synchronize';
        proxy.$refs.FacilityDialog['BaseService']
          .execProc('web4.facility__syncronize', {
            facility_id_from: synchFacilityId.value,
            facility_id_to: proxy.rowId,
          })
          .then(() =>
            proxy.$toast.add({
              severity: 'success',
              summary: 'Синхронизация завершена',
              detail: 'Данные объекта успешно синхронизированы. Обновите страницу.',
              life: 5000,
            })
          )
          .catch((er) =>
            proxy.$store.commit('SET_ERROR', {
              er: er.response || er,
              source: ['FacilityDialog', 'synchronization'],
            })
          )
          .finally(() => (modeSynch.value = null))
      }
    }

    const prepareInsert = (rowData) => {
      const data = {
        facility_id: rowData.facility_id,
        facility_name: rowData.facility_name,
        dept_id: rowData.dept_id,
        field_id: rowData.field_id ?? null,
        cluster_id: rowData.cluster_id ?? null,
        facility_process_rate: rowData.facility_process_rate,
        facility_position: rowData.facility_position ?? null,
        facility_actual: rowData.facility_actual ?? null,
        facility_mode_id: rowData.facility_mode_id,
        device_name: rowData.device_name ?? null,
        script_id: rowData.script_id ? rowData.script_id : null,
        facility_type_id: rowData.facility_type_id,
        facility_coord_lng: rowData.facility_coord_lng ? rowData.facility_coord_lng : null,
        facility_coord_ltd: rowData.facility_coord_ltd ? rowData.facility_coord_ltd : null,
      };
      return data;
    }

    const prepareUpdate = (rowData, masterDetail) => {
      const data = prepareInsert(rowData, masterDetail);
      delete data.facility_type_id;
      return data;
    }

    const prepareData = (rowData) => {
      synchFacilityId.value = null;
      dept_id.value = rowData.dept_id;
      return rowData;
    }

    const beforeOpenNewRow = (rowData) => {
      rowData.script_id = 0;
      rowData.facility_process_rate = 30;
      rowData.facility_position = 0;
      rowData.facility_mode_id = 1;
      rowData.facility_actual = true;
    }

    const onTabChange = (index) => {
      tabIndex.value = index;
    }

    const onHideDialog = () => {
      attributeText.value = '';
      propertyId.value = null;
      tabIndex.value = 0;
    }

    const changeAttribute = (data) => {
      for (const item of proxy.$refs.FacilityDialog.reference['propertyAtribute']) {
        if (item.property_attribute_id == data.property_attribute_id) {
          attributeText.value = item.property_attribute_text ? rtfToTxt(item.property_attribute_text) : '';
        }
      }
    }

    const changePropertyFacility = (data) => {
      propertyId.value = data.property_id;
      attributeText.value = '';
      attributeText.value = data.property_type_desc ? rtfToTxt(data.property_type_desc) : '';
    }

    onMounted(() => {
      replace.service = proxy.$store.getters.nameToService(
        'BaseService',
        null,
        null,
        'property'
      );
    })

    return {
      tabIndex,
      attributeText,
      propertyId,
      synchFacilityId,
      isImportLoading,
      modeSynch,
      source,
      device,
      replace,
      dept_id,
      actualDept,
      FACILITY_DIALOG_DICTIONARY,
      FACILITY_DIALOG_REQUIRED_FILEDS,

      loadData,
      dictIsReady,
      onClickReplaceAllPath,
      replaceInPath,
      onClickReplaceAllDevice,
      onClickChangePath,
      onClickChangeDevice,
      onClickUpdateFacilityProperty,
      checkDisabledImport,
      onUploadImportFile,
      onClickExport,
      prepareExport,
      download,
      synchronization,
      prepareInsert,
      prepareUpdate,
      prepareData,
      beforeOpenNewRow,
      onTabChange,
      onHideDialog,
      changeAttribute,
      changePropertyFacility,
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.p-panel-title) {
  text-align: center !important;
}

::v-deep(.p-panel-content) {
  padding: 0.2rem !important;
}

::v-deep(.p-panel.p-panel-toggleable .p-panel-header) {
  padding: 0.1rem 1rem !important;
}

::v-deep(.p-tabview .p-tabview-panels) {
  padding: 0rem;
}

::v-deep(.p-tabview-nav-link) {
  padding: 0.5rem !important;
}
</style>